module.exports = __webpack_public_path__ + "img/NO.ed7007a8.svg";